import { Settings as LuxonSettings } from 'luxon';
import store from '@/store';
import { loadLanguageAsync } from '@/i18n';
import { logGuard } from '@/router/helpers';
import { Curriculum } from '@/models/Curriculum';
import { LabelGroup, LabelGroupIncludes } from '@/models/LabelGroup';
import { OpeningHour } from '@/models/OpeningHour';
import { Period } from '@/models/Period';
import { Setting } from '@/models/Setting';
import { Tag } from '@/models/Tag';
import { TreatmentLabel } from '@/models/TreatmentLabel';
import { Year } from '@/models/Year';
import { Branding } from '@/models/Branding';
export const initializeStoreMiddleware = async (_to, _from) => {
    logGuard('[INITIALIZE_STORE_MIDDLEWARE]', _to);
    console.log('initializeStoreMiddleware');
    const doAddDetailsToLogGuard = false;
    if (!store.state.isStoreInitialized) {
        logGuard('[INITIALIZE_STORE_MIDDLEWARE] ! store.state.isStoreInitialized', !store.state.isStoreInitialized);
        const promises = [
            new Curriculum()
                .include(['children', 'subjects'])
                .current()
                .first()
                .then((curriculum) => {
                store.dispatch('loadedCurriculum', curriculum);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing erro Curriculumr', error);
                }
                throw error;
            }),
            new Period()
                .current()
                .then((period) => {
                store.dispatch('loadedCurrentPeriod', period);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Period', error);
                }
                throw error;
            }),
            new Year()
                .include('periods')
                .current()
                .then((year) => {
                store.dispatch('loadedCurrentYear', year);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Year', error);
                }
                throw error;
            }),
            new Tag()
                .all()
                .then((tags) => {
                store.dispatch('loadedTags', tags.reverse());
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Tag', error);
                }
                throw error;
            }),
            new OpeningHour()
                .all()
                .then((hours) => {
                store.dispatch('loadedOpeningHours', hours);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error OpeningHour', error);
                }
                throw error;
            }),
            new LabelGroup()
                .filter({ raw_id: '1' }) // only the default label group
                .include(LabelGroupIncludes.LABELS)
                .all()
                .then((labelGroups) => {
                const defaultLabelGroup = labelGroups[0];
                store.dispatch('loadedLabels', defaultLabelGroup ? defaultLabelGroup.labels : []);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Label', error);
                }
                throw error;
            }),
            // new Label()
            //   .all()
            //   .then((labels: Label[]) => {
            //     store.dispatch('loadedLabels', labels);
            //   })
            //   .catch((error: AxiosError) => {
            //     if (doAddDetailsToLogGuard) { logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Label', error); }
            //     throw(error);
            //   }),
            new TreatmentLabel()
                .all()
                .then((treatmentLabels) => {
                store.dispatch('loadedTreatmentLabels', treatmentLabels);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error TreatmentLabel', error);
                }
                throw error;
            }),
            Branding.fetch()
                .then((branding) => {
                store.dispatch('loadedBranding', branding);
                Branding.apply(branding);
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Branding', error);
                }
                // Non-critical, continue without branding
            }),
            new Setting()
                .limit(200)
                .all()
                .then((settings) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting Setting');
                }
                const localeSetting = settings.find((setting) => {
                    return setting.key === 'locale';
                });
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting localeSetting');
                }
                if (localeSetting && localeSetting.value) {
                    if (doAddDetailsToLogGuard) {
                        logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting localeSetting and localeSetting.value', localeSetting && localeSetting.value);
                    }
                    let lang = localeSetting.value.toLowerCase();
                    if (localeSetting.value.includes('_')) {
                        lang = localeSetting.value.split('_')[1].toLowerCase();
                    }
                    LuxonSettings.defaultLocale = lang;
                    loadLanguageAsync(lang).then((value) => {
                        if (doAddDetailsToLogGuard) {
                            logGuard('[INITIALIZE_STORE_MIDDLEWARE] loadLanguageAsync');
                        }
                        window.App.$emit('locale-changed', lang);
                    });
                }
                else {
                    if (doAddDetailsToLogGuard) {
                        logGuard('[INITIALIZE_STORE_MIDDLEWARE] else loadLanguageAsync');
                    }
                    LuxonSettings.defaultLocale = 'nl';
                    loadLanguageAsync('nl').then((value) => {
                        window.App.$emit('locale-changed', 'nl');
                    });
                }
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting versionSetting');
                }
                const versionSetting = settings.find((setting) => {
                    return setting.key === 'scool_version';
                });
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting dispatches');
                }
                store.dispatch('loadedSettings', settings);
                store.dispatch('loadedVersion', versionSetting ? versionSetting.value : '3');
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting versionSetting', versionSetting);
                }
                if (versionSetting && versionSetting.value == '1') {
                    if (doAddDetailsToLogGuard) {
                        logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting versionSetting loadLanguageAsync');
                    }
                    loadLanguageAsync('nl_v1').then((value) => {
                        if (doAddDetailsToLogGuard) {
                            logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting emits', versionSetting);
                        }
                        window.App.$emit('locale-changed', 'nl');
                        window.App.$root.$emit('locale-changed', 'nl');
                        if (doAddDetailsToLogGuard) {
                            logGuard('[INITIALIZE_STORE_MIDDLEWARE] after emits', versionSetting);
                        }
                    });
                }
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] ending Setting');
                }
            })
                .catch((error) => {
                if (doAddDetailsToLogGuard) {
                    logGuard('[INITIALIZE_STORE_MIDDLEWARE] throwing error Setting', error);
                }
                throw error;
            }),
        ];
        logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting Promise.allSettled(promises)');
        const results = await Promise.allSettled(promises);
        const rejected = results.filter((result) => result.status === 'rejected');
        if (rejected.length > 0) {
            console.warn('[INITIALIZE_STORE_MIDDLEWARE] one or more init calls failed; continuing with partial state', rejected.map((result) => result.reason));
        }
        logGuard('[INITIALIZE_STORE_MIDDLEWARE] starting setIsStoreInitialized', true);
        await store.dispatch('setIsStoreInitialized', true);
    }
    logGuard('[INITIALIZE_STORE_MIDDLEWARE] starts returning', true);
    return true;
};
